document.addEventListener('DOMContentLoaded', function () {
  Filters.init();
});

const Filters = {
  selectors: {
    "sortSelects": { selector: ".sort-by", type: "all", scope: "document" },
    "toolbar": { selector: ".toolbar", type: "single", scope: "document" },
    "filtersBtns": { selector: ".filters", type: "all", scope: "document" },
    "numberInputs": { selector: "input[type='number']", type: "all", scope: "document" },
    "allProductCards": { selector: ".product-card", type: "all", scope: "document" },
    "collection": { selector: "#collection-handle", type: "single", scope: "document" },
    "checkboxes": { selector: "input[type='checkbox'], input[type='radio']", type: "all", scope: "document" }, // lol 
    "filtersClose": { selector: ".filters-close", type: "single", scope: "document" },
    "filterCategories": { selector: ".sidebar-title", type: "all", scope: "document" },
    "loadMoreBtns": { selector: ".load-more-btn", type: "all", scope: "document" },
    "categoryDiv": { selector: ".category-div", type: "single", scope: "document" },
    "filtersForm": { selector: "#filtersForm", type: "single", scope: "document" }
  },
  init: function () {
    Utility.fetchEls(this.selectors, this);
    this.sizeMapping = {
      'Extra Small': 'XS',
      'Small': 'S',
      'Medium': 'M',
      'Large': 'L',
      'Extra Large': 'XL',
      '2X Large': '2XL',
      '3X Large': '3XL'
    };

    this.sortMap = {
      'alpha': 'title-ascending',
      'alpha-rev': 'title-descending',
      'price': 'price-ascending',
      'price-rev': 'price-descending',
      'date-rev': 'created-descending',
      'date': 'created-ascending',
      'best-selling': 'best-selling',
      'manual': 'manual'
    };

    this.filtersSelected = 0;

    if (this.collection) {
      this.collectionHandle = this.collection.dataset.handle;
      this.initFilters();
    }

    this.bindSortSelects();

    const currentUrl = new URL(window.location.href);
    const sortByParam = currentUrl.searchParams.get('sort_by');
    const reverseSortMap = {};
    for (const key in this.sortMap) {
      reverseSortMap[this.sortMap[key]] = key;
    }
    if (this.sortSelects && sortByParam && reverseSortMap[sortByParam]) {
      this.sortSelects.forEach((select) => {
        select.value = reverseSortMap[sortByParam];
      });
    }

    this.bindFilterToggleEvents();
    this.bindProductCardHover();
    this.bindLoadMoreButtons();

    if (!this.popstateBound) {
      window.addEventListener('popstate', () => {
        this.renderCollectionFromUrl(window.location.href, { updateHistory: false, replaceSidebar: true });
      });
      this.popstateBound = true;
    }

    // Initialize ScrollMagic for sticky filters
    if (this.categoryDiv) {
      this.scrollMagicController = new ScrollMagic.Controller();
      this.scrollMagicScene = null;
      this.initStickyFilters(this.categoryDiv.offsetHeight - this.categoryDiv.offsetTop);
    }
  },
  sortProducts: function (sort) {
    const selectedSort = this.sortMap[sort];
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', selectedSort);
    window.location.href = currentUrl.toString();
  },
  bindSortSelects: function () {
    if (!this.sortSelects) return;
    this.sortSelects.forEach((select) => {
      if (select.dataset.boundSort === 'true') return;
      select.dataset.boundSort = 'true';
      select.addEventListener('change', () => {
        const selectedOption = select.options[select.selectedIndex];
        const gaKey = selectedOption?.getAttribute('data-ga-key');

        if (gaKey && typeof gtag === 'function') {
          gtag('event', 'sortby_' + gaKey, {
            event_category: 'Sort By',
            item_title: selectedOption.textContent.trim()
          });
        }

        this.sortProducts(select.value);
      });
    });
  },
  bindFilterToggleEvents: function () {
    if (this.filtersBtns) {
      this.filtersBtns.forEach((btn) => {
        if (btn.dataset.boundToggle === 'true') return;
        btn.dataset.boundToggle = 'true';
        btn.addEventListener('click', () => {
          this.toggleFilters(btn);
        });
      });
    }

    if (this.filterCategories) {
      this.filterCategories.forEach((category) => {
        if (category.dataset.boundExpand === 'true') return;
        category.dataset.boundExpand = 'true';
        category.addEventListener('click', () => {
          this.toggleFilterCategory(category);
        });
      });
    }

    if (this.filtersClose && this.filtersClose.dataset.boundClose !== 'true') {
      this.filtersClose.dataset.boundClose = 'true';
      this.filtersClose.addEventListener('click', () => {
        let curBtn;
        this.filtersBtns.forEach((btn) => {
          if (window.getComputedStyle(btn).display === 'flex') {
            curBtn = btn;
          }
        });
        if (curBtn) {
          this.toggleFilters(curBtn);
        }
      });
    }
  },
  bindProductCardHover: function () {
    if (!this.allProductCards) return;
    this.allProductCards.forEach((card) => {
      const img = card.querySelector('.product-card-img');
      if (!img || img.dataset.boundHover === 'true') return;
      img.dataset.boundHover = 'true';
      img.addEventListener('mouseenter', () => {
        const nextImg = img.dataset.nextImg;
        const firstImg = img.dataset.firstImg;
        if (nextImg && firstImg) {
          img.src = nextImg;
        }
      });
      img.addEventListener('mouseleave', () => {
        const nextImg = img.dataset.nextImg;
        const firstImg = img.dataset.firstImg;
        if (nextImg && firstImg) {
          img.src = firstImg;
        }
      });
    });
  },
  bindLoadMoreButtons: function () {
    if (!this.loadMoreBtns) return;
    this.loadMoreBtns.forEach((btn) => {
      if (btn.dataset.boundLoadMore === 'true') return;
      btn.dataset.boundLoadMore = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleLoadMoreClick(btn);
      });
    });
  },
  toggleFilterCategory: function (category) {
    const container = category.closest('.filter-key');
    container.classList.contains('expanded') ? container.classList.remove('expanded') : container.classList.add('expanded');
  },

  // Price filtering for multi-currency stores that can't rely on Shopify's native price filtering. 
  // Returns true when shopCurrency !== activeCurrency (case-insensitive)
  usesClientSidePriceFilter: function () {
    const { shopCurrency, activeCurrency } = window.SelkirkStore || {};
    const shop = String(shopCurrency || '').toUpperCase();
    const active = String(activeCurrency || '').toUpperCase();
    return Boolean(shop && active && shop !== active);
  },
  // Reads min/max from .filter__min / .filter__max inputs
  getPriceFilterBounds: function () {
    const { filtersForm } = this;
    if (!filtersForm) return null;

    const minInput = filtersForm.querySelector('.filter__min');
    const maxInput = filtersForm.querySelector('.filter__max');
    if (!minInput || !maxInput) return null;

    const min = parseFloat(minInput.value);
    const max = parseFloat(maxInput.value);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return null;

    return { min, max };
  },
  // Selects all product cards across grid containers, caching the result on `this.productCards`
  getProductCards: function () {
    this.productCards = document.querySelectorAll('#product-grid .product-card, #shopify-section-collection .product-card, .main-content .product-card');
    return this.productCards;
  },
  // Reads data-presentment-price (falls back to data-price), returns dollars
  getPresentmentPrice: function (card) {
    const raw = card.dataset.presentmentPrice || card.dataset.price;
    const price = parseFloat(raw);
    return Number.isFinite(price) ? price / 100 : null;
  },
  // Hides/shows cards by price range when non-default currency; resets display when default currency
  applyClientSidePriceFilter: function () {
    // Refresh once per pass; cards change between renders so we never cache page-level.
    this.getProductCards();

    if (!this.usesClientSidePriceFilter()) {
      this.productCards.forEach((card) => {
        card.style.display = '';
      });
      const visibleCount = this.getVisibleProductCardCount();
      this.updateEmptyFilterState(visibleCount);
      return visibleCount;
    }

    const bounds = this.getPriceFilterBounds();
    if (!bounds) {
      this.updateEmptyFilterState(null);
      return null;
    }

    let visibleCount = 0;
    this.productCards.forEach((card) => {
      const price = this.getPresentmentPrice(card);
      const inRange = price !== null && price >= bounds.min && price <= bounds.max;
      card.style.display = inRange ? '' : 'none';
      if (inRange) visibleCount++;
    });

    this.updateEmptyFilterState(visibleCount);
    return visibleCount;
  },
  //Sets max input to highest visible card price (unless URL already has a price param)
  syncPriceFilterMaxToCollection: function () {
    // Default-currency shoppers keep the server-rendered (Liquid) max; this client-side
    // sync is only needed for non-default currencies where Liquid can't know presentment prices.
    if (!this.usesClientSidePriceFilter()) return;

    const { filtersForm } = this;
    if (!filtersForm) return;

    const maxInput = filtersForm.querySelector('.filter__max');
    if (!maxInput) return;

    const url = new URL(window.location.href);
    if (url.searchParams.has('price_max') || url.searchParams.has('filter.v.price.lte')) return;

    let highestCents = 0;
    this.getProductCards().forEach((card) => {
      const raw = card.dataset.presentmentPrice || card.dataset.price;
      const cents = parseFloat(raw);
      if (Number.isFinite(cents) && cents > highestCents) {
        highestCents = cents;
      }
    });

    if (highestCents <= 0) return;

    const highestValue = Math.ceil(highestCents / 100);
    const currentMax = parseFloat(maxInput.value);
    if (!Number.isFinite(currentMax) || highestValue > currentMax) {
      maxInput.value = highestValue;
      maxInput.max = Math.max(parseFloat(maxInput.max) || 0, highestValue + 500);
    }
  },
  // Restores price_min / price_max from URL on non-default currency
  restorePriceFilterFromUrl: function () {
    if (!this.usesClientSidePriceFilter() || !this.filtersForm) return;

    const url = new URL(window.location.href);
    const min = url.searchParams.get('price_min');
    const max = url.searchParams.get('price_max');
    const minInput = this.filtersForm.querySelector('.filter__min');
    const maxInput = this.filtersForm.querySelector('.filter__max');

    if (min !== null && minInput) minInput.value = min;
    if (max !== null && maxInput) maxInput.value = max;
  },
  // Writes price_min / price_max to URL via history.pushState
  syncPriceFilterToUrl: function () {
    const url = new URL(window.location.href);
    url.searchParams.delete('price_min');
    url.searchParams.delete('price_max');

    const bounds = this.getPriceFilterBounds();
    if (bounds) {
      if (bounds.min > 0) url.searchParams.set('price_min', bounds.min);
      url.searchParams.set('price_max', bounds.max);
    }

    window.history.pushState({}, '', url.toString());
  },
  // Adds custom price params to collection URLs for non-default currency
  appendCustomPriceParams: function (url) {
    if (!this.usesClientSidePriceFilter()) return;

    url.searchParams.delete('price_min');
    url.searchParams.delete('price_max');

    const bounds = this.getPriceFilterBounds();
    if (!bounds) return;

    if (bounds.min > 0) url.searchParams.set('price_min', bounds.min);
    url.searchParams.set('price_max', bounds.max);
  },
  // Counts visible product cards by checking computed styles (since some may be hidden via CSS rather than display:none)
  getVisibleProductCardCount: function () {
    const cardsToCount = this.productCards || this.getProductCards();
    let count = 0;
    cardsToCount.forEach((card) => {
      if (card.style.display === 'none') return;
      if (window.getComputedStyle(card).display === 'none') return;
      count++;
    });
    return count;
  },
  // Determines if any filters are active by checking URL params, checked inputs, and price filter values against defaults
  hasActiveFilterSelection: function () {
    const url = new URL(window.location.href);
    for (const key of url.searchParams.keys()) {
      if (key.indexOf('filter.') === 0 || key === 'price_min' || key === 'price_max') {
        return true;
      }
    }

    const { filtersForm } = this;
    if (!filtersForm) return false;

    const facetInputs = filtersForm.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
    for (const input of facetInputs) {
      if (input.name && input.name !== 'category-filter') return true;
    }

    const bounds = this.getPriceFilterBounds();
    if (!bounds) return false;

    const minInput = filtersForm.querySelector('.filter__min');
    const maxInput = filtersForm.querySelector('.filter__max');
    const defaultMin = parseFloat(minInput?.dataset?.defaultMin ?? minInput?.defaultValue ?? 0);
    const defaultMax = parseFloat(maxInput?.dataset?.defaultMax ?? maxInput?.defaultValue);

    if (bounds.min > defaultMin) return true;
    if (Number.isFinite(defaultMax) && bounds.max < defaultMax) return true;

    return false;
  },
  // Ensures the empty filter element exists in the DOM and returns it
  ensureEmptyFilterElement: function () {
    let emptyEl = document.getElementById('collection-empty-filters');
    if (emptyEl) return emptyEl;

    const grid = document.getElementById('product-grid');
    if (!grid) return null;

    emptyEl = document.createElement('p');
    emptyEl.id = 'collection-empty-filters';
    emptyEl.className = 'empty-collection collection-empty-filters';
    emptyEl.textContent = 'There are no products matching your selected filters.';
    emptyEl.hidden = true;
    emptyEl.style.display = 'none';
    grid.insertAdjacentElement('afterend', emptyEl);
    return emptyEl;
  },
  // Updates the state of the empty filter message based on visible product count and active filters
  updateEmptyFilterState: function (visibleCount = null) {
    const emptyEl = this.ensureEmptyFilterElement();
    if (!emptyEl) return;

    const count = visibleCount !== null ? visibleCount : this.getVisibleProductCardCount();
    const hasMorePages = Boolean(document.querySelector('.load-more-btn'));
    const showEmpty = count === 0 && this.hasActiveFilterSelection() && !hasMorePages;

    emptyEl.hidden = !showEmpty;
    emptyEl.style.display = showEmpty ? 'block' : 'none';

    const loadMore = document.querySelector('.load-more-container');
    if (loadMore) {
      loadMore.style.removeProperty('display');
    }
  },
  getFilters: function () {
    const { filtersData, filtersForm } = this;
    if (!filtersData) {
      console.error('Failed to load filter configuration');
      return;
    }

    const filters = {
      price: {
        min: filtersForm.querySelector('.filter__min').value,
        max: filtersForm.querySelector('.filter__max').value
      }
    };

    filtersData.filters.forEach((filter) => {
      const filterKey = filter.label.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => {
        return chr.toUpperCase();
      });

      if (this.loadMoreBtns) {
        this.loadMoreBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.trackLoadMoreClick();
            this.handleLoadMoreClick(btn);
          });
        });
      }

      const inputs = filtersForm.querySelectorAll(`input[name="${filter.values[0].param_name}"]:checked`);
      filters[filterKey] = Array.from(inputs).map((input) => {
        return input.value;
      });
    });

    return filters;
  },

  normalizeSizes: function (sizes) {
    return sizes.map(size => this.sizeMapping[size] || size);
  },

  filterProducts: function (e, filters) {
    e.preventDefault();
    const { filtersBtn } = this;
    const allProducts = document.querySelectorAll('.main-content .product-card');
    let visibleCount = 0;

    allProducts.forEach((product, index) => {
      let isVisible = true;

      Object.keys(filters).forEach((key) => {
        const filterValues = filters[key];
        if (key == 'price') {
          const price = this.getPresentmentPrice(product);
          if (price === null || price < parseFloat(filters.price.min) || price > parseFloat(filters.price.max)) {
            isVisible = false;
          }
        } else if (key == 'handleLength' && filterValues.length > 0) {
          const handleLengthFilters = {
            '5 - 5.49': { min: 5, max: 5.49 },
            '5.5+': { min: 5.5, max: Infinity },
            'Under 5': { min: 0, max: 4.99 }
          };
          const handleLength = parseFloat(product.dataset.handleLength);
          let handleLengthMatch = filterValues.some(selectedRange => {
            const { min, max } = handleLengthFilters[selectedRange];
            return handleLength >= min && handleLength <= max;
          });
          if (!handleLengthMatch) {
            isVisible = false;
          }
        } else if (filterValues.length > 0) {
          if (!product.dataset[key]) {
            // console.log(`Missing data for key: ${key} on product: ${product.dataset.title}`);
            isVisible = false;
          } else {
            let productData = product.dataset[key];
            try {
              productData = JSON.parse(productData);
            } catch (e) {
              productData = productData.split(',').map(item => item.trim());
            }

            if (!Array.isArray(productData)) {
              productData = [productData];
            }

            if (key === 'size') {
              productData = this.normalizeSizes(productData);
            }

            // Case-insensitive comparison
            const productDataLower = productData.map(item => String(item).toLowerCase());
            const hasRequiredData = filterValues.some(value => productDataLower.includes(value.toLowerCase()));

            if (!hasRequiredData) {
              isVisible = false;
            }
          }
        }
      });

      if (isVisible) {
        visibleCount++;
      }

      // Set display property based on visibility
      product.style.display = isVisible ? 'flex' : 'none';
    });

    this.updateEmptyFilterState(visibleCount);

    if (visibleCount < 16) {
      const loadMoreBtn = document.querySelector('.load-more-btn');
      if (loadMoreBtn && !loadMoreBtn.disabled) {
        this.handleLoadMoreClick(loadMoreBtn);
        return;
      }
    }

    if (window.innerWidth < 1201) {
      this.toggleFilters(filtersBtn);
    }
  },
  toggleFilters: function (btn) {
    const filtersContainer = document.querySelector('.filters-container');
    const screen = window.innerWidth > 768 ? '.desktop' : '.mobile';
    const filtersText = btn.querySelector(`.filters-text${screen}`);
    const filters = document.querySelector('.filter-sidebar');
    if (filtersText.textContent.includes('Show')) {
      this.showFilters(filtersText, filters, filtersContainer);
    } else {
      this.hideFilters(filtersText, filters, filtersContainer);
    }
  },
  hideFilters: function (filtersText, filters, container) {
    filtersText.textContent = 'Show Filters';
    filters.style.display = 'none';
    if (container) {
      container.style.display = 'none';
    }
  },
  showFilters: function (filtersText, filters, container) {
    filtersText.textContent = 'Hide Filters';
    filters.style.display = 'block';
    if (container) {
      container.style.display = 'block';
    }
  },
  hasActiveFilters: function (filters) {
    return Object.values(filters).some(value => {
      if (Array.isArray(value)) {
        return value.length > 0; // Check if any array filters are not empty
      }
      if (typeof value === 'object' && value !== null) {
        // Check if price filter has valid min and max values
        return parseFloat(value.min) > 0 || parseFloat(value.max) < 270;
      }
      return false; // Default for unhandled types
    });
  },
  buildFilterParamsFromForm: function () {
    const { filtersForm } = this;
    const params = new URLSearchParams();
    if (!filtersForm) return params;

    const fields = filtersForm.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
    fields.forEach((field) => {
      if (!field.name || field.name === 'category-filter') return;
      params.append(field.name, field.value);
    });

    const minInput = filtersForm.querySelector('.filter__min');
    const maxInput = filtersForm.querySelector('.filter__max');
    if (!this.usesClientSidePriceFilter()) {
      if (minInput && minInput.dataset.paramName && minInput.value !== '') {
        params.set(minInput.dataset.paramName, minInput.value);
      }
      if (maxInput && maxInput.dataset.paramName && maxInput.value !== '') {
        params.set(maxInput.dataset.paramName, maxInput.value);
      }
    }

    return params;
  },
  buildNextCollectionUrl: function (collectionHandle = null) {
    const currentUrl = new URL(window.location.href);
    const nextParams = this.buildFilterParamsFromForm();

    // Remove existing filter params before appending current selection.
    const keys = Array.from(currentUrl.searchParams.keys());
    keys.forEach((key) => {
      if (key.indexOf('filter.') === 0) {
        currentUrl.searchParams.delete(key);
      }
    });
    currentUrl.searchParams.delete('page');
    currentUrl.searchParams.delete('price_min');
    currentUrl.searchParams.delete('price_max');

    nextParams.forEach((value, key) => {
      currentUrl.searchParams.append(key, value);
    });

    this.appendCustomPriceParams(currentUrl);

    if (collectionHandle) {
      currentUrl.pathname = `/collections/${collectionHandle}`;
    }

    return currentUrl.toString();
  },
  setFilterLoadingState: function (isLoading) {
    const grid = document.getElementById('product-grid') || document.getElementById('shopify-section-collection');
    if (grid) {
      grid.style.opacity = isLoading ? '0.6' : '';
      grid.style.pointerEvents = isLoading ? 'none' : '';
    }
  },
  replaceCollectionMarkup: function (doc, options = {}) {
    const { replaceSidebar = true } = options;

    const currentSection = document.getElementById('shopify-section-collection');
    const nextSection = doc.getElementById('shopify-section-collection');

    if (currentSection && nextSection && replaceSidebar) {
      currentSection.innerHTML = nextSection.innerHTML;
    } else {
      const currentGrid = document.getElementById('product-grid');
      const nextGrid = doc.getElementById('product-grid');
      if (currentGrid && nextGrid) {
        currentGrid.innerHTML = nextGrid.innerHTML;
      }

      const currentLoadMore = document.querySelector('.load-more-container');
      const nextLoadMore = doc.querySelector('.load-more-container');
      if (currentLoadMore && nextLoadMore) {
        currentLoadMore.replaceWith(nextLoadMore);
      } else if (currentLoadMore && !nextLoadMore) {
        currentLoadMore.remove();
      } else if (!currentLoadMore && nextLoadMore && currentGrid && currentGrid.parentNode) {
        currentGrid.parentNode.appendChild(nextLoadMore);
      }
    }

    if (replaceSidebar) {
      const currentSidebar = document.querySelector('.filter-sidebar');
      const nextSidebar = doc.querySelector('.filter-sidebar');
      if (currentSidebar && nextSidebar) {
        currentSidebar.innerHTML = nextSidebar.innerHTML;
      }
    }
  },
  refreshBindingsAfterRender: function () {
    Utility.fetchEls(this.selectors, this);
    if (this.collection) {
      this.collectionHandle = this.collection.dataset.handle;
    }
    this.bindSortSelects();
    this.bindFilterToggleEvents();
    this.bindFilterInputEvents();
    this.bindLoadMoreButtons();
    this.bindProductCardHover();

    if (typeof ProductCards !== 'undefined') {
      ProductCards.init();
    }

    this.syncPriceFilterMaxToCollection();
    this.restorePriceFilterFromUrl();
    this.applyClientSidePriceFilter();
    this.updateEmptyFilterState();
  },
  renderCollectionFromUrl: async function (nextUrl, options = {}) {
    const { updateHistory = true, replaceSidebar = false } = options;

    if (this.pendingFilterRequest) {
      this.pendingFilterRequest.abort();
    }
    const controller = new AbortController();
    this.pendingFilterRequest = controller;

    const uiState = replaceSidebar ? this.captureFilterUiState() : null;

    this.setFilterLoadingState(true);
    try {
      // Use Shopify's section rendering endpoint when available to avoid fetching/parsing the full page.
      // This page already swaps markup from specific nodes (`#shopify-section-collection`, `.filter-sidebar`, etc.),
      // so fetching only the active section keeps bandwidth + DOMParser work lower.
      const collectionSectionEl = document.getElementById('shopify-section-collection');
      const sectionId = collectionSectionEl?.dataset?.sectionId;

      let renderUrl = nextUrl;
      if (sectionId) {
        const url = new URL(nextUrl);
        url.searchParams.set('section_id', sectionId);
        renderUrl = url.toString();
      }

      const response = await fetch(renderUrl, {
        signal: controller.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      if (!response.ok) throw new Error('Failed to fetch filtered collection');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      this.replaceCollectionMarkup(doc, { replaceSidebar });

      if (updateHistory) {
        window.history.pushState({}, '', nextUrl);
      }

      this.refreshBindingsAfterRender();

      if (replaceSidebar && uiState) {
        this.restoreFilterUiState(uiState);
        this.autoExpandActiveFilters();
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.location.href = nextUrl;
      }
    } finally {
      if (this.pendingFilterRequest === controller) {
        this.pendingFilterRequest = null;
      }
      this.setFilterLoadingState(false);
    }
  },
  navigateWithFilters: function (collectionHandle = null) {
    const nextUrl = this.buildNextCollectionUrl(collectionHandle);
    if (collectionHandle) {
      // Collection-switch radios still do a full navigation to ensure all page-level content is refreshed.
      window.location.href = nextUrl;
      return;
    }
    this.renderCollectionFromUrl(nextUrl, { updateHistory: true, replaceSidebar: false });
  },
  bindFilterInputEvents: function () {
    if (this.checkboxes) {
      this.checkboxes.forEach((checkbox) => {
        if (checkbox.dataset.boundFilterChange === 'true') return;
        checkbox.dataset.boundFilterChange = 'true';

        if (checkbox.name === 'category-filter') {
          checkbox.addEventListener('change', (event) => {
            this.navigateWithFilters(event.target.dataset.handle);
          });
        } else {
          checkbox.addEventListener('change', () => {
            this.navigateWithFilters();
          });
        }
      });
    }

    if (this.numberInputs) {
      this.numberInputs.forEach((input) => {
        if (input.dataset.boundPriceChange === 'true') return;
        input.dataset.boundPriceChange = 'true';

        let typingTimer;
        const typingDelay = 300;
        input.addEventListener('input', () => {
          clearTimeout(typingTimer);
          typingTimer = setTimeout(() => {
            if (this.usesClientSidePriceFilter()) {
              this.syncPriceFilterToUrl();
              this.applyClientSidePriceFilter();
              return;
            }
            this.navigateWithFilters();
          }, typingDelay);
        });
      });
    }
  },
  initFilters: async function () {
    this.bindFilterInputEvents();
    this.syncPriceFilterMaxToCollection();
    this.restorePriceFilterFromUrl();
    this.applyClientSidePriceFilter();
    this.updateEmptyFilterState();
    this.autoExpandActiveFilters();
  },
  fetchFilters: async function () {
    try {
      const response = await fetch(`/collections/${this.collectionHandle}?view=filters`);
      if (!response.ok) throw new Error('Network response was not ok');
      const filtersData = await response.json();
      this.filtersData = filtersData;
    } catch (error) {
      console.error('Final attempt failed:', error);
      return null;
    }
  },
  fetchCategoryProducts: function (handle) {
    if (!handle) return;
    this.navigateWithFilters(handle);
  },
  handleLoadMoreClick: function (button) {
    const url = button.dataset.url;

    button.querySelector('.load-more-text').textContent = 'Loading...';
    button.disabled = true;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        let newProducts = doc.querySelectorAll('#product-grid .product-card');
        if (newProducts.length === 0) {
          newProducts = doc.querySelectorAll('#shopify-section-collection .product-card');
        }
        const productGrid = document.getElementById('product-grid') || document.getElementById('shopify-section-collection');

        newProducts.forEach(product => {
          productGrid.appendChild(product.cloneNode(true));
        });

        this.bindProductCardHover();
        this.syncPriceFilterMaxToCollection();
        this.applyClientSidePriceFilter();

        const newButton = doc.querySelector('.load-more-btn');
        const buttonContainer = button.closest('.load-more-container');

        if (newButton) {
          button.dataset.url = newButton.dataset.url;
          button.querySelector('.load-more-text').textContent = 'Load More';
          button.disabled = false;

          const newInfo = doc.querySelector('.pagination-info');
          if (newInfo) {
            buttonContainer.querySelector('.pagination-info').textContent = newInfo.textContent;
          }
        } else {
          buttonContainer.remove();
        }

      })
      .catch(error => {
        console.error('Error loading more products:', error);
        button.querySelector('.load-more-text').textContent = 'Error - Try Again';
        button.disabled = false;
      });
  },
  autoExpandActiveFilters: function () {
    const form = document.querySelector('#filtersForm');
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach((input) => {
      const section = input.closest('.filter-key');
      if (section) section.classList.add('expanded');
    });
  },
  captureFilterUiState: function () {
    const expandedIds = [];
    document.querySelectorAll('.filter-key.expanded').forEach((el) => {
      if (el.id) expandedIds.push(el.id);
    });
    const sidebar = document.querySelector('.filter-sidebar');
    const container = document.querySelector('.filters-container');
    return {
      expandedIds,
      sidebarDisplay: sidebar ? sidebar.style.display : '',
      containerDisplay: container ? container.style.display : '',
      sidebarScrollTop: sidebar ? sidebar.scrollTop : 0,
    };
  },
  restoreFilterUiState: function (state) {
    if (!state) return;
    state.expandedIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.add('expanded');
    });
    const sidebar = document.querySelector('.filter-sidebar');
    const container = document.querySelector('.filters-container');
    if (sidebar) {
      if (state.sidebarDisplay !== undefined) sidebar.style.display = state.sidebarDisplay;
      sidebar.scrollTop = state.sidebarScrollTop || 0;
    }
    if (container && state.containerDisplay !== undefined) {
      container.style.display = state.containerDisplay;
    }
  },
  initStickyFilters: function (duration) {
    const oneRem = parseFloat(
      window.getComputedStyle(document.querySelector("html")).fontSize
    );

    // Variable to track whether the current state is desktop
    let isDesktop = window.innerWidth >= 1200;

    // Function to initialize ScrollMagic only for desktop
    const setupScrollMagic = () => {
      // Check if the screen width is 1200px or larger
      if (window.innerWidth >= 1200) {
        // Remove the old scene if it exists
        if (this.scrollMagicScene) {
          this.scrollMagicScene.destroy(true); // Ensure complete cleanup
          this.scrollMagicController.removeScene(this.scrollMagicScene);
          this.scrollMagicScene = null;
        }

        this.scrollMagicScene = new ScrollMagic.Scene({
          triggerElement: ".filters-container",
          triggerHook: 0,
          offset: -2 * oneRem,
          duration: duration,
        })
          .setPin(".filters-container")
          .addTo(this.scrollMagicController);
      }
    };

    // Setup ScrollMagic when page is first loaded
    setupScrollMagic();

    // Listen for resize events and update ScrollMagic
    window.addEventListener('resize', () => {
      // Track the new state (desktop or mobile)
      const newIsDesktop = window.innerWidth >= 1200;

      // Only proceed if the state has changed (e.g., from desktop to mobile or vice versa)
      if (newIsDesktop !== isDesktop) {
        if (newIsDesktop) {
          // Transitioning from mobile to desktop, initialize ScrollMagic
          setupScrollMagic();
        } else {
          // Transitioning from desktop to mobile, destroy the ScrollMagic scene
          if (this.scrollMagicScene) {
            this.scrollMagicScene.destroy(true); // Cleanup for mobile
            this.scrollMagicController.removeScene(this.scrollMagicScene);
            this.scrollMagicScene = null;
          }
        }

        // Update the current state
        isDesktop = newIsDesktop;
      }
    });
  }
};


